<!--
作者：Loong
时间：2020/07/17
-->
<!-- UserInfoChange [ 业主信息修改 ] -->
<template>

    <div id='userInfoChange'>
        <div class="userInfoChangeBox">

            <div class="editInfoItem">
                <ul>
                    <li>
                        <span class="editInfoItem_label">户号</span>
                        <el-input v-model="dataset.account" placeholder="请输入户号" style="width: 300px;" :maxlength="12" :disabled="type==3 || type==2" @blur="onblur"></el-input>
                    </li>
                    <!-- <li>
                        <span class="editInfoItem_label">业主姓名</span>
                        <el-input v-model="dataset.name" placeholder="请输入业主姓名" style="width: 200px;" :disabled="true"></el-input>
                    </li>
                    <li>
                        <span class="editInfoItem_label">业主手机</span>
                        <el-input v-model="dataset.phone" placeholder="请输入业主手机" style="width: 200px;" :maxlength="11" :disabled="true"></el-input>
                    </li> -->
                    <li>
                        <span class="editInfoItem_label">缴费金额</span>
                        <el-input type="number" v-model="dataset.money" placeholder="请输入缴费金额" style="width: 200px;" :disabled="type==3" :maxlength="11" ></el-input>
                    </li>
                    <!-- <li>
                        <span class="editInfoItem_label">地址</span>
                        <el-input v-model="dataset.address" placeholder="请输入地址" style="width: 200px;" :maxlength="11" :disabled="true" ></el-input>
                    </li> -->
                    <li>
                        <span class="editInfoItem_label">费用周期</span>
                        <el-date-picker v-model="dataset.begin_date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="开始时间" style="width:170px;" :disabled="type==3"> </el-date-picker>
                        <el-date-picker v-model="dataset.end_date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="结束时间" style="width:170px;" :disabled="type==3"> </el-date-picker>
                    </li>
                    <!-- <li>
                        <span class="editInfoItem_label">缴费时间</span>
                        <el-date-picker v-model="dataset.start_time" type="date" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd" placeholder="缴费时间" style="width:200px;" :disabled="true"> </el-date-picker>
                    </li>
                    <li>
                        <span class="editInfoItem_label">状态</span>
                        <el-select v-model="dataset.status" placeholder="请选择" style="width: 140px;" :disabled="true">
                            <el-option :label="'已缴费'" :value="1"></el-option>
                            <el-option :label="'未缴费'" :value="0"></el-option>
                        </el-select>
                    </li> -->
                    <li>
                        <span class="editInfoItem_label">缴费明细</span>
                        <el-input v-model="dataset.payment_detail" placeholder="请输入缴费明细" style="width: 200px;" :disabled="type==3" ></el-input>
                    </li>
                    <li>
                        <span class="editInfoItem_label">备注</span>
                        <el-input v-model="dataset.remark" placeholder="请输入备注" style="width: 200px;" :disabled="type==3" ></el-input>
                    </li>
                </ul>
            </div>

            <div class="editInfoItem" style=" text-ailgn: center" :class="type == 3 ? 'dis' : ''">
                <el-button type="primary" style="width:120px; margin-left: 330px;" @click="onSubmit()" v-if="type != 3">提交</el-button>
                <el-button style="width: 120px;margin-bottom: 20px; margin-left: 30px;" @click="$emit('onClose')">关闭</el-button>
            </div>

        </div>
    </div>

</template>

<script>
export default {
    components: { },

    props: ['loadData', 'type'],

    data() {
        return{
            dataset: {
                id: null,
                account: '',
                name: '',
                phone: '',
                money: '',
                address: '',
                begin_date: '',
                end_date: '',
                start_time: '',
                status: '',
                payment_detail: '',
                remark: ''
            },

            idKey: null,
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){
            if(this.type != 1){
                this.dataset.id = this.loadData.id;
                this.dataset.account = this.loadData.account;
                this.dataset.name = this.loadData.name;
                this.dataset.phone = this.loadData.phone;
                this.dataset.money = this.loadData.money;
                this.dataset.address = this.loadData.address;
                this.dataset.begin_date = this.loadData['begin-end'] ? this.loadData['begin-end'].split('至')[0] : '';
                this.dataset.end_date = this.loadData['begin-end'] ? this.loadData['begin-end'].split('至')[1] : '';
                this.dataset.start_time = this.loadData.pay_time;
                this.dataset.status = Number(this.loadData.status);
                this.dataset.payment_detail = this.loadData.payment_detail;
                this.dataset.remark = this.loadData.remark;
            } else {
                this.dataset.status = 0;
            }
        },

        getData(){
            
        },

        onSubmit(){
            if(this.dataset.account == '' || this.dataset.account == null){
                this.$message({ type:'warning', message: '请输入户号', duration:2000 });
                return;
            }
            if(this.dataset.money == '' || this.dataset.money == null){
                this.$message({ type:'warning', message: '请输入缴费金额', duration:2000 });
                return;
            }
            if(this.dataset.begin_date == '' || this.dataset.begin_date == null){
                this.$message({ type:'warning', message: '请输入费用周期开始时间', duration:2000 });
                return;
            }
            if(this.dataset.end_date == '' || this.dataset.end_date == null){
                this.$message({ type:'warning', message: '请输入费用周期结束时间', duration:2000 });
                return;
            }
            
            let inStart = typeof(this.dataset.begin_date) != 'string' ? this.dataset.begin_date.getTime() : new Date(this.dataset.begin_date).getTime();
            let inEnd = typeof(this.dataset.end_date) != 'string' ? this.dataset.end_date.getTime() : new Date(this.dataset.end_date).getTime();

            if(inStart > inEnd){
                this.$message({ type:'warning', message: '开始时间不能大于结束时间', duration:2000 });
                return;
            }

            let start = typeof(this.dataset.begin_date) != 'string' ? this.foDate(this.dataset.begin_date) : this.dataset.begin_date;
            let end = typeof(this.dataset.end_date) != 'string' ? this.foDate(this.dataset.end_date) : this.dataset.end_date;
            if(this.type == 1){
                this.$jssdk.property.addInfo({
                    community_time_id: this.$route.query.id,
                    account: this.dataset.account,
                    payment_money: this.dataset.money,
                    begin_date: start,
                    end_date: end,
                    remark: this.dataset.remark,
                    payment_detail: this.dataset.payment_detail
                }, (r) =>{
                    this.$message({
                        type:'success',
                        message: '添加完成',
                        duration:2000
                    });
                    this.$emit('onClose');
                },(err) =>{
                    this.$message({
                        type:'warning',
                        message:err.msg,
                        duration:2000
                    })
                });
            } else {
                this.$jssdk.property.editInfo({
                    id: this.dataset.id,
                    account: this.dataset.account,
                    payment_money: this.dataset.money,
                    begin_date: start,
                    end_date: end,
                    remark: this.dataset.remark,
                    payment_detail: this.dataset.payment_detail
                }, (r) =>{
                    this.$message({
                        type:'success',
                        message: '修改完成',
                        duration:2000
                    });
                    this.$emit('onClose');
                },(err) =>{
                    this.$message({
                        type:'warning',
                        message:err.data,
                        duration:2000
                    })
                });
            }
        },

        foDate(date){
            let y = date.getFullYear();
                y = y < 10 ? ('0' + y) : y;
            let m = date.getMonth() + 1;
                m = m < 10 ? ('0' + m) : m;
            let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
            
            return y + '-' + m + '-' + d;
        },

        onblur(){
            return ;
            if(this.type == 1){
                this.$jssdk.property.getAccount({
                    account: this.dataset.account,
                }, (r) =>{
                    this.dataset.name = r.name;
                    this.dataset.address = r.address;
                    this.dataset.phone = r.phone;
                },(err) =>{
                    this.$message({
                        type:'warning',
                        message:err.msg,
                        duration:2000
                    })
                });
            }
        },
    },
}
</script>

<style lang='less'>

</style>

<style lang='less' scoped>
    #userInfoChange{
        position: absolute;
		top: 0;
        left: 0;
        right: 0;
        bottom: 0;
		z-index: 6;
        background-color: rgba(0,0,0,.7);
        
        .userInfoChangeBox{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 900px;
            max-height: 90%;
            border:2px solid #8fceff;
            border-radius: 10px;
            box-shadow: 5px 10px 10px rgba(51,51,51,.3);
            background-color: #ffffff;
            overflow-y: auto;

            .editInfoItem_label{
                display: inline-block;
                width: 75px;
            }
            .editInfoItem ul{
                overflow:hidden;
                list-style: none;
                padding: 0;
                margin-left: 10px;
            }
            .editInfoItem ul li{
                float: left;
                font-size: 14px;
                margin: 20px 12px  7px  7px !important;
                
            }
            .editInfoItem ul li:nth-child(1){
                width: 400px;
            }
            .editInfoItem ul li:last-child{
                line-height: 50px;
                height: 50px;
            }
        }

        .editInfoItem.dis{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>


// WEBPACK FOOTER //
// PropertyInfoChangeEdit.vue?c5131918